// Promo Code Enums
export enum PromoCodeType {
  SINGLE_USE = 'SINGLE_USE',
  PUBLIC_ACCOUNT = 'PUBLIC_ACCOUNT',
  PUBLIC_CHARACTER = 'PUBLIC_CHARACTER',
  PERSONAL_ACCOUNT = 'PERSONAL_ACCOUNT',
  PERSONAL_CHARACTER = 'PERSONAL_CHARACTER',
  PUBLIC_GAME_ACCOUNT = 'PUBLIC_GAME_ACCOUNT',
  PERSONAL_GAME_ACCOUNT = 'PERSONAL_GAME_ACCOUNT'
}

export enum PromoCodeStatus {
  NOT_STARTED = 'NOT_STARTED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

// Promo Code DTOs
export interface PromoCodeItemDto {
  baseItemId: number;
  quantity: number;
  name?: string;
  iconName?: string;
  iconPanel?: string;
  itemType?: string;
}

export interface PromoCodeListDto {
  id: number;
  code: string;
  name: string;
  groupName?: string;
  type: PromoCodeType;
  validFrom: string;
  validTo: string;
  activationsCount: number;
  status: PromoCodeStatus;
  createdAt: string;
  updatedAt: string;
}

export interface PromoCodeDto {
  id: number;
  code: string;
  name: string;
  groupName?: string;
  type: PromoCodeType;
  validFrom: string;
  validTo: string;
  personalUserId?: number;
  moneyAmount?: number;
  tokensAmount?: number;
  race?: string;
  items?: PromoCodeItemDto[];
  activationsCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePromoCodeDto {
  code?: string;
  name: string;
  groupName?: string;
  type: PromoCodeType;
  validFrom: string;
  validTo: string;
  personalUserId?: number;
  moneyAmount?: number;
  tokensAmount?: number;
  race?: string;
  items?: PromoCodeItemDto[];
}

export interface UpdatePromoCodeDto {
  name: string;
  groupName?: string;
  validFrom: string;
  validTo: string;
}

export interface ActivatePromoCodeDto {
  code: string;
  characterName?: string;
  gameAccountLogin?: string;
}

export interface CreateBatchPromoCodeDto {
  quantity: number;
  name: string;
  groupName?: string;
  validFrom: string;
  validTo: string;
  moneyAmount?: number;
  tokensAmount?: number;
  race?: string;
  items?: PromoCodeItemDto[];
}

export interface GeneratedPromoCodesDto {
  codes: string[];
  count: number;
}

export interface PaginatedPromoCodeDto {
  content: PromoCodeListDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface PromoCodePreviewDto {
  code: string;
  moneyAmount?: number;
  tokensAmount?: number;
  race?: string;
  items?: PromoCodeItemDto[];
  available?: boolean;
  requiresCharacter?: boolean;
  requiresGameAccount?: boolean;
}

// Promo Code Group Stats
export interface PromoGroupStatsDto {
  groupName: string;
  totalCodes: number;
  usedCodes: number;
}

// Promo Code Stats Types
export interface PromoActivationStatsDto {
  totalActivations: number;
  uniqueUsers: number;
  uniqueCodes: number;
  totalMoneyGiven: number;
  totalTokensGiven: number;
  uniqueItemCount: number;
  totalItemQuantity: number;
  raceStats: Record<string, number>;
}

export interface PromoActivationUserStatsDto {
  userId: number;
  username: string;
  race?: string;
  totalActivations: number;
  totalMoneyReceived: number;
  totalTokensReceived: number;
  uniqueItemCount: number;
  totalItemQuantity: number;
}

export interface PaginatedPromoActivationUserStatsDto {
  content: PromoActivationUserStatsDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}

export interface PromoActivationHistoryDto {
  id: number;
  userId: number;
  username: string;
  code: string;
  promoCodeName: string;
  promoCodeType: PromoCodeType;
  characterName?: string;
  activatedAt: string;
}

export interface PaginatedPromoActivationHistoryDto {
  content: PromoActivationHistoryDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}

export interface PromoActivationCodeStatsDto {
  promoCodeId: number;
  code: string;
  name: string;
  type: PromoCodeType;
  totalActivations: number;
}

export interface PaginatedPromoActivationCodeStatsDto {
  content: PromoActivationCodeStatsDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}
